module.exports = __webpack_public_path__ + "img/story023.ffe0d906.webp";